<app-splash-screen></app-splash-screen>
<!-- Toaster -->
<app-notifier></app-notifier>
<router-outlet></router-outlet>
